import { LOCAL_STORAGE_ACCESS_TOKEN } from "../../constants";
import { login, logout, refresh } from "./asyncThunks";
import { getAdminUserInfo } from "../user/asyncThunks";

export const loginBuilder = (builder) => {
  builder.addCase(login.pending, (state) => {
    state.loginPending = true;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { accessToken, adminUser } = action.payload;
    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, accessToken);
    // Ne čuvamo refresh token u localStorage, već se oslanjamo na cookie
    state.loginPending = false;
    state.loggedIn = true;
    state.token = accessToken;
    state.user = adminUser; // Store user info including role
  });
  builder.addCase(login.rejected, (state) => {
    state.loginPending = false;
  });
};

export const logoutBuilder = (builder) => {
  builder.addCase(logout.pending, (state) => {
    state.loggedIn = false;
  });
  builder.addCase(logout.fulfilled, () => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    // Ne brišemo refresh token iz localStorage jer se oslanjamo na cookie
  });
  builder.addCase(logout.rejected, (state) => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    // Ne brišemo refresh token iz localStorage jer se oslanjamo na cookie
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { accessToken, adminUser } = action.payload;
    state.token = accessToken;
    state.loggedIn = true;
    // If adminUser is provided in refresh response, store it
    if (adminUser) {
      state.user = adminUser;
    }
  });
  builder.addCase(refresh.rejected, (state) => {
    state.loggedIn = false;
    state.user = null;
  });
};

export const getAdminUserInfoBuilder = (builder) => {
  builder.addCase(getAdminUserInfo.pending, (state) => {
    state.getAdminUserInfoPending = true;
  });
  builder.addCase(getAdminUserInfo.fulfilled, (state, { payload }) => {
    state.getAdminUserInfoPending = false;
    state.user = payload;
  });
  builder.addCase(getAdminUserInfo.rejected, (state) => {
    state.getAdminUserInfoPending = false;
  });
};
